<template>
  <div class="list-search">
    <form>
      <div class="row row-clear-sm-6-md-4">
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <label class="sr-only">Keywords</label>

            <input name="keywords" v-model="stateKeywords" type="text" class="form-control" placeholder="Keywords" />
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="form-group" v-if="$userIsAdmin && showRegionFilter && regionOptions.length > 1">
            <label class="sr-only">Region</label>
            <selectize
              ref="regions"
              class="selectize selectize-multiple"
              multiple
              name="region"
              v-model="stateRegions"
              placeholder="Region"
              :options="regionOptions"/>
          </div>
        </div>
        <slot name="additional-filters"></slot>
        <div class="text-right spacer-r-2">
          <div class="form-group">
            <slot name="button"/>

            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { stateMapper } from 'mixins/users/filters'
import { mapActions } from 'vuex'
import { map } from 'lodash'
import Selectize from './ext/codium/CodiumSelectize'

export default {
  mixins: [stateMapper],

  props: {
    setFilterMutation: {
      required: true,
      type: Function
    },
    filters: {
      required: true,
      type: Object
    },
    applyFilters: {
      required: false,
      type: Function
    },
    showRegionFilter: {
      required: false,
      default: true
    }
  },

  components: {
    Selectize
  },

  data () {
    return {
      regionOptions: []
    }
  },

  created () {
    if (this.$userIsAdmin && this.showRegionFilter && !this.$vlastMode) {
      this.getRegions()
        .then((response) => {
          this.regionOptions = map(response.data, region => ({id: region.id, text: region.name}))
          this.stateRegions = [this.$user.region_id]
          if (this.applyFilters) {
            this.applyFilters()
          }
        })
    }
  },

  methods: {
    ...mapActions('region', ['getRegions'])
  }
}
</script>
